import CustomTable from '../../component/CustomTable';

export default function PeersData({peersData, setColumn}) {
        return (
          <div> 
              <div className="pl-1 pr-4 pb-4 mb-4  ">
                
                  {peersData && <CustomTable
                                  key={setColumn.dataField}
                                  columndata={setColumn}
                                  marketdata={peersData}
                                  redirectlink="/stocks/"
                                  pageSizeNumber="10"
                                /> 
                            } 
              </div>
          </div>
        )
      }
